import fetchApi from './api';
import fetchApiBlob from './apiBlob';
import {ApiResponse, LoginResponse, SearchPaging} from 'models/model';
const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || '';

export const ScheduleGetPaging = async (searchPaging?: SearchPaging): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Schedule/GetPaging', {
        method: 'POST',
        body: searchPaging ? JSON.stringify(searchPaging) : '{}'
    });
};
export const ScheduleGet = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Schedule/Get', {
        method: 'POST',
        body: JSON.stringify({id})
    });
};

export const ScheduleCreate = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Schedule/Create', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const ScheduleCreateRepeat = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Schedule/CreateRepeat', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const ScheduleUpdate = async (data: any): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Schedule/Update', {
        method: 'POST',
        body: JSON.stringify(data)
    });
};

export const ScheduleDelete = async (id: string): Promise<ApiResponse> => {
    return fetchApi<ApiResponse>('/Schedule/Delete', {
        method: 'POST',
        body: JSON.stringify({id})
    });
};

export const ScheduleExport = async (id: string): Promise<any> => {
    // const url = `${API_BASE_URL}/Schedule/Export`;
    // const response = await fetch(url, {
    //     body: JSON.stringify({ id }),
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //         'Accept': 'application/json'
    //     },
    // });
    //
    // if (!response.ok) {
    //     throw new Error("Tải file mẫu thất bại");
    // }
    //
    // return await response.blob();
    return fetchApiBlob<any>('/Schedule/Export', {
        body: JSON.stringify({id}),
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
        },
    });
}



